import React from "react";
import { Eye, EyeOff, Clapperboard } from "lucide-react";
import { useLang, BLOG_INFO } from "../../context/LangContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";

export function BlogVisibilitySettings({ s, set }) {
  const { t, lang } = useLang();
  const hidden = s.hidden_blogs || [];
  const toggle = (b, visible) => set("hidden_blogs", visible ? hidden.filter((x) => x !== b) : [...hidden, b]);
  return (
    <div className="rounded-2xl border border-white/10 bg-card p-6 space-y-4" data-testid="blog-visibility-settings">
      <h3 className="font-heading font-bold flex items-center gap-2"><Eye className="h-4 w-4 text-primary" />{t("Blogs visíveis no site", "Blogs visible on the site")}</h3>
      <p className="text-xs text-muted-foreground">{t("Um blog desativado deixa de aparecer no site público (menus, listagens, artigos, RSS e sitemap). O conteúdo continua guardado.", "A disabled blog disappears from the public site (menus, listings, articles, RSS and sitemap). Content is kept.")}</p>
      {Object.keys(BLOG_INFO).map((b) => {
        const visible = !hidden.includes(b);
        return (
          <label key={b} className="flex items-center justify-between text-sm">
            <span className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: BLOG_INFO[b].color }} />
              {lang === "pt" ? BLOG_INFO[b].pt : BLOG_INFO[b].en}
              {!visible && <span className="inline-flex items-center gap-1 text-xs text-muted-foreground"><EyeOff className="h-3 w-3" />{t("oculto", "hidden")}</span>}
            </span>
            <Switch data-testid={`blog-visible-${b}`} checked={visible} onCheckedChange={(v) => toggle(b, v)} />
          </label>
        );
      })}
    </div>
  );
}

export function DubbingSettings({ s, set }) {
  const { t } = useLang();
  return (
    <div className="rounded-2xl border border-white/10 bg-card p-6 space-y-4" data-testid="dubbing-settings">
      <h3 className="font-heading font-bold flex items-center gap-2"><Clapperboard className="h-4 w-4 text-primary" />{t("Dobragem de vídeos", "Video dubbing")}</h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <Label className="text-xs">{t("Duração de cada parte (segundos)", "Length of each part (seconds)")}</Label>
          <Input data-testid="set-dub-part-seconds" type="number" min={30} className="mt-1.5" value={s.dub_part_seconds ?? 120}
            onChange={(e) => set("dub_part_seconds", Math.max(30, Number(e.target.value) || 120))} />
        </div>
        <div>
          <Label className="text-xs">{t("Duração máxima do vídeo (minutos)", "Max video length (minutes)")}</Label>
          <Input data-testid="set-dub-max-minutes" type="number" min={1} className="mt-1.5" value={s.dub_max_minutes ?? 15}
            onChange={(e) => set("dub_max_minutes", Math.max(1, Number(e.target.value) || 15))} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{t("O vídeo é cortado em partes deste tamanho para transcrever, traduzir e dobrar. No fim, as partes são juntas num único MP4.", "The video is split into parts of this length to transcribe, translate and dub, then joined back into one MP4.")}</p>
    </div>
  );
}
